<template>
  <div class="invoice-view">
    <v-card flat>
      <ReportViewBar :title="title" :start="start" :end="end" />

      <v-card-text>
        <table class="center">
          <tbody class="report-container">
            <v-card-text>
              <InvoiceReport :start="start" :end="end" />
            </v-card-text>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
const InvoiceReport = () => import("@/modules/ReportView/GlobalReport/Invoice.vue");

export default {
  name: "invoice-by-date-report",

  props: {
    title: {
      type: String,
      default: "Invoice By Date",
    },
  },

  data() {
    return {
      start: null,
      end: null,
    };
  },

  created() {
    this.start = this.$route.query.start;
    this.end = this.$route.query.end;
  },

  components: {
    ReportViewBar,
    InvoiceReport,
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
